"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _reactNumberFormat = _interopRequireDefault(require("react-number-format"));

var _Icon = _interopRequireDefault(require("../../Icon/Icon"));

var _useFiltersState3 = require("./useFiltersState");

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var spacing = _ref.spacing;
  return {
    root: {
      position: 'absolute'
    },
    paperRoot: {
      width: '100%',
      maxWidth: '402px',
      boxShadow: '0px 0px 0px 0px #fff, 0px 16px 24px 2px rgba(0,0,0,0.14), 0px 0px 0px 0px #fff'
    },
    chip: {
      margin: spacing(0, 0.25, 0.5, 0.25)
    }
  };
});
/**
 * @typedef FilterItem
 * @property {number} value
 * @property {string} label
 */

/**
 * @typedef MarketplaceFilters
 * @property {Array<FilterItem>} types
 * @property {Array<FilterItem>} categories
 */

/**
 * @typedef MarketplacePriceFilters
 * @property {number|undefined|null} minPrice
 * @property {number|undefined|null} maxPrice
 * @property {number|undefined|null} giftCardPrice
 * @property {number|undefined|null} donationAmount
 */

/**
 * Marketplace filters sidebar.
 *
 * ! OnFilter callback called when "Apply Filters" clicked.
 *
 * @param {object} props
 * @param {boolean} props.isOpen
 * @param {boolean} [props.disableBudget=false]
 * @param {boolean} [props.syncBudget=false]
 * @param {function (): void} props.onClose
 * @param {function ({ types: Array<number>, categories: Array<number>, price?: MarketplacePriceFilters }): void} props.onFilter
 * @param {{ types: Array<number>, categories: Array<number>, price?: MarketplacePriceFilters }} props.appliedFilters
 * @param {MarketplaceFilters} props.filters
 * @param {Object} [props.styleProps] props.styleProps - props.styleProps
 * @param {number} [props.styleProps.paddingBottomCategory=12] - props.styleProps.paddingBottomCategory
 * @param {number} [props.styleProps.applyFiltersPosition=0] - props.styleProps.applyFiltersPosition
 * @param props.isMultipleGiftCardValuesEnabled
 * @returns {React.ReactNode}
 * @example
 * export const AwesomeFilters = () => {
 * const [isOpen, setIsOpen] = useState(false);
 * const [value, setValue] = useState({ types: [], categories: [] });
 * const filters = useMemo(() => ({
 * types: [{ value: 1, label: 'Gift card' }, { value: 2, label: 'Donation' }],
 * categories: [{ value 1, label: 'Art' }, { value: 2, label: 'Adventure' }],
 * }), []);
 *
 * return (
 * <MarketplaceFilters
 * isOpen={isOpen}
 * onClose={useCallback(() => { setIsOpen(false) }, [])}
 * onFilter={setValue}
 * filters={filters}
 * appliedFilters={value}
 * styleProps={value}
 * />
 * );
 * }
 */

var MarketplaceFilters = function MarketplaceFilters(_ref2) {
  var isOpen = _ref2.isOpen,
      onClose = _ref2.onClose,
      onFilter = _ref2.onFilter,
      filters = _ref2.filters,
      appliedFilters = _ref2.appliedFilters,
      styleProps = _ref2.styleProps,
      disableBudget = _ref2.disableBudget,
      syncBudget = _ref2.syncBudget,
      _ref2$isMultipleGiftC = _ref2.isMultipleGiftCardValuesEnabled,
      isMultipleGiftCardValuesEnabled = _ref2$isMultipleGiftC === void 0 ? false : _ref2$isMultipleGiftC;
  var classes = useStyles();

  var _useFiltersState = (0, _useFiltersState3.useFiltersState)(appliedFilters),
      _useFiltersState2 = (0, _slicedToArray2["default"])(_useFiltersState, 2),
      state = _useFiltersState2[0],
      _useFiltersState2$ = _useFiltersState2[1],
      setType = _useFiltersState2$.setType,
      unsetType = _useFiltersState2$.unsetType,
      setCategories = _useFiltersState2$.setCategories,
      unsetCategory = _useFiltersState2$.unsetCategory,
      setMinPrice = _useFiltersState2$.setMinPrice,
      setMaxPrice = _useFiltersState2$.setMaxPrice,
      setGiftCardPrice = _useFiltersState2$.setGiftCardPrice,
      setDonationAmount = _useFiltersState2$.setDonationAmount,
      setBudget = _useFiltersState2$.setBudget;

  var _appliedFilters$price = appliedFilters.price,
      price = _appliedFilters$price === void 0 ? {} : _appliedFilters$price;
  (0, _react.useEffect)(function () {
    if (syncBudget) {
      setBudget(price);
    }
  }, [setBudget, price, syncBudget]);
  var onTypeToggle = (0, _react.useCallback)(function (_ref3) {
    var target = _ref3.target;

    if (target.checked) {
      setType(Number(target.value));
      return;
    }

    unsetType(Number(target.value));
  }, [setType, unsetType]);
  var onCategorySelect = (0, _react.useCallback)(function (_ref4) {
    var target = _ref4.target;
    setCategories(target.value);
  }, [setCategories]);
  var noop = (0, _react.useCallback)(function () {}, []);
  var onCategoryUnselect = (0, _react.useCallback)(function (event) {
    event.stopPropagation();
    var value = event.currentTarget.dataset.value;
    unsetCategory(Number(value));
  }, [unsetCategory]);
  var onApply = (0, _react.useCallback)(function () {
    onFilter(state);
  }, [onFilter, state]);
  var menuItems = (0, _react.useMemo)(function () {
    return filters.categories.map(function (_ref5) {
      var value = _ref5.value,
          label = _ref5.label;
      return /*#__PURE__*/_react["default"].createElement(_material.MenuItem, {
        key: value,
        value: value
      }, label);
    });
  }, [filters]);
  var renderSelectedCategories = (0, _react.useCallback)(function (selected) {
    return /*#__PURE__*/_react["default"].createElement(_material.Box, {
      display: "flex",
      flexWrap: "wrap"
    }, selected.map(function (value) {
      return /*#__PURE__*/_react["default"].createElement(_material.Chip, {
        size: "small",
        key: value,
        className: classes.chip,
        onDelete: noop,
        deleteIcon: /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
          "data-value": value,
          onMouseDown: onCategoryUnselect,
          icon: "times-circle"
        }),
        label: filters.categories.find(function (cat) {
          return cat.value === value;
        }).label
      });
    }));
  }, [classes, filters, noop, onCategoryUnselect]);
  return /*#__PURE__*/_react["default"].createElement(_material.Drawer, {
    open: isOpen,
    disablePortal: true,
    hideBackdrop: true,
    transitionDuration: 0,
    anchor: "right",
    classes: {
      root: classes.root
    },
    PaperProps: {
      classes: {
        root: classes.paperRoot
      }
    }
  }, /*#__PURE__*/_react["default"].createElement(_material.Box, {
    px: 2,
    pt: 2,
    pb: styleProps.paddingBottomCategory
  }, /*#__PURE__*/_react["default"].createElement(_material.Box, {
    pb: 2,
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between"
  }, /*#__PURE__*/_react["default"].createElement(_material.Box, {
    className: "H4-Dark"
  }, "Filters"), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    icon: "times",
    onClick: onClose
  })), /*#__PURE__*/_react["default"].createElement(_material.Box, {
    p: 2,
    borderRadius: "5px",
    bgcolor: "common.white"
  }, /*#__PURE__*/_react["default"].createElement(_material.Box, {
    className: "Label-Table-Left-Active"
  }, "ITEM TYPES"), /*#__PURE__*/_react["default"].createElement(_material.Box, {
    pt: 1,
    pb: 1
  }, /*#__PURE__*/_react["default"].createElement(_material.Divider, null)), /*#__PURE__*/_react["default"].createElement(_material.Box, {
    display: "flex",
    flexDirection: "Column"
  }, filters.types.map(function (type) {
    return /*#__PURE__*/_react["default"].createElement(_material.Box, {
      key: type.value
    }, /*#__PURE__*/_react["default"].createElement(_material.FormControlLabel, {
      control: /*#__PURE__*/_react["default"].createElement(_material.Checkbox, {
        color: "secondary",
        checked: state.types.includes(type.value),
        value: type.value,
        onChange: onTypeToggle
      }),
      label: type.label
    }));
  }))), state.price && /*#__PURE__*/_react["default"].createElement(_material.Box, {
    p: 2,
    mt: 2,
    borderRadius: "5px",
    bgcolor: "common.white"
  }, /*#__PURE__*/_react["default"].createElement(_material.Box, {
    className: "Label-Table-Left-Active"
  }, "PRICE"), /*#__PURE__*/_react["default"].createElement(_material.Box, {
    pt: 1,
    pb: 2
  }, /*#__PURE__*/_react["default"].createElement(_material.Divider, null)), /*#__PURE__*/_react["default"].createElement(_material.Box, {
    display: "flex"
  }, /*#__PURE__*/_react["default"].createElement(_material.Box, null, /*#__PURE__*/_react["default"].createElement(_reactNumberFormat["default"], {
    onValueChange: function onValueChange(_ref6) {
      var floatValue = _ref6.floatValue;
      return setMinPrice(floatValue);
    },
    decimalScale: 0,
    disabled: disableBudget,
    allowNegative: false,
    customInput: _material.TextField,
    thousandSeparator: true,
    prefix: "$",
    placeholder: "$",
    InputLabelProps: {
      shrink: true
    },
    value: state.price.minPrice === null ? '' : state.price.minPrice,
    variant: "outlined",
    label: "Minimum"
  })), /*#__PURE__*/_react["default"].createElement(_material.Box, {
    ml: 1
  }, /*#__PURE__*/_react["default"].createElement(_reactNumberFormat["default"], {
    onValueChange: function onValueChange(_ref7) {
      var floatValue = _ref7.floatValue;
      return setMaxPrice(floatValue);
    },
    decimalScale: 0,
    disabled: disableBudget,
    allowNegative: false,
    customInput: _material.TextField,
    thousandSeparator: true,
    prefix: "$",
    placeholder: "$",
    InputLabelProps: {
      shrink: true
    },
    value: state.price.maxPrice === null ? '' : state.price.maxPrice,
    variant: "outlined",
    label: "Maximum"
  }))), !isMultipleGiftCardValuesEnabled && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_material.Box, {
    mt: 2,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between"
  }, /*#__PURE__*/_react["default"].createElement(_material.Typography, null, "Gift card price"), /*#__PURE__*/_react["default"].createElement(_material.Box, {
    ml: 2,
    flex: "0 1 170px"
  }, /*#__PURE__*/_react["default"].createElement(_reactNumberFormat["default"], {
    onValueChange: function onValueChange(_ref8) {
      var floatValue = _ref8.floatValue;
      return setGiftCardPrice(floatValue);
    },
    decimalScale: 0,
    disabled: disableBudget,
    allowNegative: false,
    customInput: _material.TextField,
    thousandSeparator: true,
    prefix: "$",
    placeholder: "$",
    InputLabelProps: {
      shrink: true
    },
    value: state.price.giftCardPrice === null ? '' : state.price.giftCardPrice,
    variant: "outlined",
    label: "Max amount"
  }))), /*#__PURE__*/_react["default"].createElement(_material.Box, {
    mt: 2,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between"
  }, /*#__PURE__*/_react["default"].createElement(_material.Typography, null, "Donation amount"), /*#__PURE__*/_react["default"].createElement(_material.Box, {
    ml: 2,
    flex: "0 1 170px"
  }, /*#__PURE__*/_react["default"].createElement(_reactNumberFormat["default"], {
    onValueChange: function onValueChange(_ref9) {
      var floatValue = _ref9.floatValue;
      return setDonationAmount(floatValue);
    },
    decimalScale: 0,
    disabled: disableBudget,
    allowNegative: false,
    customInput: _material.TextField,
    thousandSeparator: true,
    prefix: "$",
    placeholder: "$",
    InputLabelProps: {
      shrink: true
    },
    value: state.price.donationAmount === null ? '' : state.price.donationAmount,
    variant: "outlined",
    label: "Amount"
  }))))), /*#__PURE__*/_react["default"].createElement(_material.Box, {
    p: 2,
    mt: 2,
    borderRadius: "5px",
    bgcolor: "common.white"
  }, /*#__PURE__*/_react["default"].createElement(_material.Box, {
    className: "Label-Table-Left-Active"
  }, "CATEGORIES"), /*#__PURE__*/_react["default"].createElement(_material.Box, {
    pt: 1,
    pb: 2
  }, /*#__PURE__*/_react["default"].createElement(_material.Divider, null)), filters.categories.length > 0 && /*#__PURE__*/_react["default"].createElement(_material.FormControl, {
    variant: "outlined",
    fullWidth: true
  }, /*#__PURE__*/_react["default"].createElement(_material.InputLabel, {
    id: "marketplace-filters-categories-label"
  }, "Select a category"), /*#__PURE__*/_react["default"].createElement(_material.Select, {
    multiple: true,
    label: "Select a category",
    value: state.categories,
    onChange: onCategorySelect,
    renderValue: renderSelectedCategories,
    id: "marketplace-filters-categories-select",
    labelId: "marketplace-filters-categories-label"
  }, menuItems)))), /*#__PURE__*/_react["default"].createElement(_material.Box, {
    position: "fixed",
    bottom: styleProps.applyFiltersPosition,
    bgcolor: "common.white",
    width: 400,
    p: 2,
    boxShadow: "0 2px 8px 0 rgba(0, 0, 0, 0.1)",
    zIndex: "appBar"
  }, /*#__PURE__*/_react["default"].createElement(_material.Button, {
    startIcon: /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      color: "inherit",
      icon: "check"
    }),
    fullWidth: true,
    variant: "contained",
    color: "secondary",
    onClick: onApply
  }, "Apply filters")));
};

MarketplaceFilters.propTypes = {
  isOpen: _propTypes["default"].bool.isRequired,
  onClose: _propTypes["default"].func.isRequired,
  onFilter: _propTypes["default"].func.isRequired,
  filters: _propTypes["default"].shape({
    types: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      value: _propTypes["default"].number.isRequired,
      label: _propTypes["default"].string.isRequired
    })).isRequired,
    categories: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      value: _propTypes["default"].number.isRequired,
      label: _propTypes["default"].string.isRequired
    })).isRequired
  }).isRequired,
  appliedFilters: _propTypes["default"].shape({
    types: _propTypes["default"].arrayOf(_propTypes["default"].number).isRequired,
    categories: _propTypes["default"].arrayOf(_propTypes["default"].number).isRequired,
    price: _propTypes["default"].shape({
      minPrice: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].oneOf([null, undefined])]),
      maxPrice: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].oneOf([null, undefined])]),
      giftCardPrice: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].oneOf([null, undefined])]),
      donationAmount: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].oneOf([null, undefined])])
    })
  }).isRequired,
  styleProps: _propTypes["default"].shape({
    paddingBottomCategory: _propTypes["default"].number,
    applyFiltersPosition: _propTypes["default"].number
  }),
  disableBudget: _propTypes["default"].bool,
  syncBudget: _propTypes["default"].bool,
  isMultipleGiftCardValuesEnabled: _propTypes["default"].bool
};
MarketplaceFilters.defaultProps = {
  disableBudget: false,
  syncBudget: false,
  isMultipleGiftCardValuesEnabled: false,
  styleProps: {
    paddingBottomCategory: 12,
    applyFiltersPosition: 0
  }
};

var _default = /*#__PURE__*/(0, _react.memo)(MarketplaceFilters);

exports["default"] = _default;